import { render, staticRenderFns } from "./addTenant.vue?vue&type=template&id=d5f454ba&lang=pug"
import script from "./addTenant.vue?vue&type=script&lang=js"
export * from "./addTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports